<template>
    <div v-if="Jdetail.detail" class="us-jrn-all-contaier">
        <div class="edt-det-box clearfix">
            <div class="buchungsanfrage" style="display:none;"></div>
            <Buchung v-if="showBuchung" :reisename="Jdetail.detail.title" :termine="Jdetail.dates"></Buchung>
            <div class="col-md-8 clearfix">
                <div class="edt-det-l1 edt-box-shadow" v-if="Jdetail.images.length > 0">
                    <div>
                        <div class="bigpic_reise" :style="`background-image: url(${Jdetail.images[0].link}), linear-gradient(to right, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${Jdetail.images[0].link});`">
                            <div class="reise_copyright reisedetail_copyright">{{ Jdetail.images[0].picture.copyright }}</div>
                        </div>
                    </div>
                    <div id="edt-det-carousel" class="edt-det-carousel carousel slide" data-ride="carousel">
                        <div class="carousel-inner" role="listbox">
                            <div class="item active">
                                <!-- <div v-for="(image, imageindex) in Jdetail.images" :key="'image' + imageindex">
                                    <div class="smallpic_reise" :style="`background-image: url('${image.link}')`" :image_link="image.link">
                                        <div class="reise_copyright reisedetail_copyright">{{ image.picture.copyright }}</div>
                                    </div>
                                </div> -->
                                <div v-for="(image, imageindex) in Jdetail.images" :key="'image' + imageindex">
                                    <el-image :src="image.link" fit="scale-down" class="smallpic_reise" :image_link="image.link"> </el-image>
                                    <div class="reise_copyright reisedetail_copyright">{{ image.picture.copyright }}</div>
                                </div>
                                <div v-if="Jdetail.detail.reisekarte != null">
                                    <el-image :src="`https://lit.unisigns.de/Bilder_Druck/web/${(Jdetail.detail.reisekarte).toString().padStart(10, '0')}.jpg.webp`" fit="scale-down" class="smallpic_reise" :image_link="`https://lit.unisigns.de/Bilder_Druck/web/${(Jdetail.detail.reisekarte).toString().padStart(10, '0')}.jpg.webp`"> </el-image>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="edt-det-l2">
                    <div class="col-sm-6" v-for="(date, dateindex) in Jdetail.dates.filter(d => d.status == 1)" :key="date.id_pln_dates">
                        <div class="edt-det-l2-item edt-box-shadow">
                            <div class="edt-det-l2-item-line">
                                <div class="l2-item-label-box">
                                    <div class="l2-item-label edt-blue-label">
                                        <p v-if="Jdetail.dates.filter(d => d.status == 1).length == 1">Termin</p>
                                        <p v-else>Termin {{ dateindex + 1 }}</p>
                                        <div></div>
                                    </div>
                                </div>
                                <div class="l2-item-label-box-line">
                                    <label>{{ getJourneyDate(date.dates) }}</label>
                                    <div>{{ getJourneyDuration(date.dates) }}</div>
                                </div>
                                <div class="l2-item-label-box-line">
                                    <label>Reisestatus</label>
                                    <div>
                                        Buchbar
                                    </div>
                                </div>
                                <div class="l2-item-border-box"></div>
                            </div>
                            <div class="edt-det-l2-item-line">
                                <div class="l2-item-label-box">
                                    <div class="l2-item-label edt-orange-label">
                                        <p>Preise</p>
                                        <div></div>
                                    </div>
                                </div>
                                <div v-for="(price, priceindex) in date.dates.prices" :key="date.id_pln_dates + 'price_' + priceindex" class="l2-item-label-box-line preise" data-toggle="tooltip" title="" data-original-title="Preis pro Person im DZ">
                                    <label>{{ price.name }}</label>
                                    <div :class="priceindex === 0 ? 'l2-item-active edt-text-blue' : ''">{{ (price.price / 1000000).toFixed(2).replace(".", ",") }} €</div>
                                </div>
                                <!-- 
                                <div class="l2-item-label-box-line preise" data-toggle="tooltip" title="" data-original-title="Preis pro Person im DZ">
                                    <label>Preis pro Person im DZ</label>
                                    <div class="l2-item-active edt-text-blue">1.136,00 €</div>
                                </div>
                                <div class="l2-item-label-box-line preise" data-toggle="tooltip" title="" data-original-title="Preis pro Person im EZ">
                                    <label>Preis pro Person im EZ</label>
                                    <div>1.228,00 €</div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="edt-det-r1 edt-box-shadow">
                    <div class="edt-det-r1-label edt-blue-label">
                        <p>{{ Jdetail.detail.title }}</p>
                        <div></div>
                    </div>
                    <div class="edt-det-r1-cont">
                        <div class="edt-det-r1-description" v-if="journeyDescription != ''" v-html="journeyDescription"></div>

                        <div class="edt-det-r1-description-2" v-for="day in Jdetail.days" :key="day.title">
                            <div class="edt-text-blue edt-line-header">{{ day.title }}</div>
                            <div class="edt-text-normal edt-line-text">{{ day.text }}</div>
                        </div>

                        <div class="edt-det-r1-description-label-box" v-if="Jdetail.detail.highlights != '' && Jdetail.detail.highlights != null">
                            <div class="edt-det-r1-description-label edt-blue-label">
                                <p>Highlights</p>
                                <div></div>
                            </div>
                        </div>

                        <div class="edt-det-r1-description-3">
                            <ul v-html="Jdetail.detail.highlights"></ul>
                        </div>

                        <div class="edt-det-r1-description-label-box" v-if="Jdetail.detail.leistungen != ''">
                            <div class="edt-det-r1-description-label edt-blue-label">
                                <p>Leistungen</p>
                                <div></div>
                            </div>
                        </div>
                        <div class="edt-det-r1-description-3">
                            <ul v-html="Jdetail.detail.leistungen"></ul>
                        </div>

                        <div class="edt-det-r1-description-label-box" v-if="Jdetail.detail.hinweise != '' && Jdetail.detail.hinweise != null">
                            <div class="edt-det-r1-description-label edt-blue-label">
                                <p>Hinweise</p>
                                <div></div>
                            </div>
                        </div>
                        <div class="edt-det-r1-description-3">
                            <ul v-html="Jdetail.detail.hinweise"></ul>
                        </div>

                        <div class="edt-det-r1-but"><button class="btn btn-warning buchungsbutton buchungsbuttonauswahl" pid="8222" rid="3032" @click="showBuchung = true">Reise Anfrage</button></div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 clearfix edt-det-r1-infobox">
                <!-- <div class="col-md-4"><h2 class="edt-text-orange">Mehrtagesreise</h2></div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Buchung from "./formulare/Buchung"

export default {
    computed: {
        journeyDescription() {
            let _desc = []
            if (this.Jdetail.detail.einleitung && this.Jdetail.detail.einleitung !== "") {
                _desc.push(this.Jdetail.detail.einleitung)
            }
            if (this.Jdetail.detail.hotelbeschreibung && this.Jdetail.detail.hotelbeschreibung !== "") {
                _desc.push(this.Jdetail.detail.hotelbeschreibung)
            }

            return _desc.join("<br><br>")
        }
    },
    components: {
        Buchung
    },
    mounted() {
        this.setJourneys()
    },
    data() {
        return {
            showframe: false,
            framesrc: "",
            Jdetail: {},
            showBuchung: false,
            swiperOptionTop: {
                spaceBetween: 5,
                loop: true,
                loopedSlides: 4, //looped slides should be the same
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            swiperOptionThumbs: {
                spaceBetween: 5,
                slidesPerView: 4,
                touchRatio: 0.2,
                loop: true,
                loopedSlides: 4, //looped slides should be the same
                slideToClickedSlide: true
            }
        }
    },
    watch: {
        $route(to, from) {
            this.setJourneys()
        }
    },
    methods: {
        setJourneys() {
            let args = core.getPathArgs(["id"])
            core.backend("jrn.getJourneyWeb", { id_jrn_journey: args.id }, (err, res) => {
                this.Jdetail = JSON.parse(JSON.stringify(res.data))

                if (this.Jdetail.detail.leistungen != "") {
                    this.Jdetail.detail.leistungen = "<li>" + JSON.parse(JSON.stringify(this.Jdetail.detail.leistungen.replace(/\n/g, "</li><li>")))
                }
                if (this.Jdetail.days.length === 1) {
                    if (this.Jdetail.days[0].title == "1. Tag" && this.Jdetail.days[0].text == "") {
                        this.Jdetail.days = []
                    }
                }

                this.Jdetail.dates = this.Jdetail.dates.filter(d => new Date(d.dates.date_from) > new Date())
            })
        },
        getJourneyDate(jrn) {
            if (jrn.date_from == jrn.date_till) {
                return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from))
            }
            return new Intl.DateTimeFormat("de-DE", { month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from)) + " - " + new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_till))
        },
        getJourneyDuration(jrn) {
            if (jrn.date_from == jrn.date_till) {
                return "1 Tag"
            }
            return Math.round((new Date(jrn.date_till) - new Date(jrn.date_from)) / 1000 / 60 / 60 / 24 + 1) + " Tage"
        },
        formatDate(date) {
            return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(date))
        },
        getReiseStatus(stat) {
            switch (stat) {
                case "A":
                    return { icon: "times-square", style: { color: "red" } }
                case "F":
                    return { icon: "check-square", style: { color: "green" } }
                default:
                    return { icon: "minus-square", style: { color: "orange" } }
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.edt-det-r1 .edt-det-r1-description-2 .edt-line-header {
    font-weight: bold;
    margin-bottom: 0;
}
</style>